// src/composables/useCache.ts
import { useContext } from "@nuxtjs/composition-api";
var useCache = () => {
  const { req } = useContext();
  const isCacheEnabled = req && req.$vsfCache ? req.$vsfCache.enabled : false;
  if (!req || !isCacheEnabled) {
    return {
      addTags: () => {
      },
      clearTags: () => {
      },
      getTags: () => [],
      setTags: () => {
      }
    };
  }
  const $vsfCache = req.$vsfCache;
  const addTags = (tags) => tags.forEach((tag) => $vsfCache.tagsSet.add(tag));
  const clearTags = () => $vsfCache.tagsSet.clear();
  const getTags = () => Array.from($vsfCache.tagsSet);
  const setTags = (fn) => {
    const tagsSet = $vsfCache.tagsSet;
    const newTags = fn(Array.from(tagsSet));
    tagsSet.clear();
    newTags.forEach((tag) => tagsSet.add(tag));
  };
  return {
    addTags,
    clearTags,
    getTags,
    setTags
  };
};

// src/index.ts
var CacheTagPrefix = /* @__PURE__ */ ((CacheTagPrefix2) => {
  CacheTagPrefix2["Product"] = "P";
  CacheTagPrefix2["Category"] = "C";
  CacheTagPrefix2["Attribute"] = "A";
  CacheTagPrefix2["Cart"] = "B";
  CacheTagPrefix2["Filter"] = "F";
  CacheTagPrefix2["Block"] = "O";
  CacheTagPrefix2["View"] = "V";
  return CacheTagPrefix2;
})(CacheTagPrefix || {});
export {
  CacheTagPrefix,
  useCache
};
